import { createAction } from '@reduxjs/toolkit';

import { resetCustomLoginDataSuccess, setCustomLoginData } from './reducers';

export const resetCustomLoginDataRequest = createAction(
  'auth/resetCustomLoginDataRequest',
);

export { resetCustomLoginDataSuccess, setCustomLoginData };

export const SET_CUSTOM_LOGIN_DATA = setCustomLoginData.type;
export const RESET_CUSTOM_LOGIN_DATA_SUCCESS = resetCustomLoginDataSuccess.type;
export const RESET_CUSTOM_LOGIN_DATA_REQUEST = resetCustomLoginDataRequest.type;
